import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';


@Component({
  selector: 'app-loginapp',
  templateUrl: './loginapp.component.html',
  styleUrls: ['./loginapp.component.scss']
})
export class LoginappComponent implements OnInit {    
  loginForm: FormGroup;


  constructor( public router: Router) { }

  

  ngOnInit(): void {

  }

  onSubmit(password: string) {
    console.log(password)
    if (password == 'gt123'){
      this.router.navigate(['main']);
      localStorage.setItem('approved','true')
    
    } else 
    alert('Wrong Password')
  }

}
